module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading'), _vm._v(" "), _c('div', {
    staticClass: "middle-box  text-center loginscreen animated fadeInDown"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.account),
      expression: "user.account"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Account",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('alert-compact', {
    attrs: {
      "errors": _vm.errors
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary block full-width m-b",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _vm._m(1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('img', {
    staticStyle: {
      "max-height": "40px",
      "max-width": "90%"
    },
    attrs: {
      "src": "/static/img/common/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "m-t"
  }, [_c('small', [_vm._v("Copyright (C) UNIQUERY Inc. All Rights Reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c02a52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Login.vue
// module id = 468
// module chunks = 1